import { GetCategoryAttributesResp } from 'types/api/response/get-category-attributes-resp'

import { api } from './api'

export const getCategoryAttributes = (categoryId: number) =>
  api.get<GetCategoryAttributesResp>('/item_upload/catalog_attributes', {
    params: { catalog_id: categoryId },
  })
